module.exports = __webpack_public_path__ + "static/img/iconfont.269919f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1551407126619
// module id = 0sPm
// module chunks = 212